export const checkScrollToBottom = (event, mistake = 20) => {
  const element = event.target || event;
  const { scrollHeight, clientHeight, scrollTop } = element;

  return scrollHeight - clientHeight - mistake <= scrollTop;
};
